import { SelectRole } from "@components/role/select-role";
import { getDisabledRoles } from "@utils/workspace-role-utils";
import { SelectCompanyRoleProps } from "@components/role/select-role-utils";
import { FaroCoreApiConst, FaroCoreApiTypes } from "@stellar/core-api-client";

/**
 *  Renders a dropdown to select company role
 *  TODO: Refactor this component to handle only TableCell fields, as it is no longer used for non-TableCell fields
 *  https://faro01.atlassian.net/browse/ST-2993.
 */
export function SelectCompanyRole<
  T extends FaroCoreApiTypes.AssignmentRoleBySubjectType["company"]
>({
  selectedRole,
  onChange,
  onResetSelection,
  variant,
  isRequired = true,
  shouldAllowAllRolesSelection = false,
  menuProps,
}: SelectCompanyRoleProps<T>): JSX.Element {
  function onSelectRoleChange(role: FaroCoreApiTypes.CompanyRole): void {
    // TODO: Type assertion will be fixed in https://faro01.atlassian.net/browse/ST-1902
    onChange(role as T);
  }

  /**
   * Decides which roles to show disabled.
   * If shouldAllowAllRolesSelection is true, then no roles will be disabled.
   * Otherwise, it will show roles that are not assignable based on the selected role.
   * TODO: Type assertion will be fixed in https://faro01.atlassian.net/browse/ST-1902
   */
  const disabledRoles: FaroCoreApiTypes.AssignmentRoleBySubjectType["company"][] =
    shouldAllowAllRolesSelection || !selectedRole
      ? []
      : (getDisabledRoles(
          selectedRole
        ) as FaroCoreApiTypes.AssignmentRoleBySubjectType["company"][]);

  return (
    <SelectRole
      label="Workspace role"
      roles={FaroCoreApiConst.allCompanyRoles}
      disabledRoles={disabledRoles}
      variant={variant}
      selectedRole={selectedRole}
      onChange={onSelectRoleChange}
      onResetSelection={onResetSelection}
      link="workspaceRolesHelp"
      isRequired={isRequired}
      menuProps={menuProps}
    />
  );
}
